import { Heading } from "../../../../atoms";
import { Flex } from "../../../../cores";
import { useViewContext } from "../../../../hooks";
import { IKeyStringAndValue } from "../../../../types/Types";
import MiljoPointsDescription from "./EnvironmentPointsDescription";

interface IEnvironmentDescription {
  emptyFilterOptions: boolean;
  filterOptions: IKeyStringAndValue | undefined;
  descriptionTitle: string;
  descriptionText: Array<string>;
}
const EnvironmentDescription = ({
  emptyFilterOptions,
  filterOptions,
  descriptionTitle,
  descriptionText,
}: IEnvironmentDescription) => {
  const { isMobile } = useViewContext();
  return !emptyFilterOptions ? (
    (filterOptions as IKeyStringAndValue)["typeOfPump"] !== "fl" ? (
      <Flex
        sx={{
          width: ["100%", null, "50%", "25%", "25%"],
          flexDirection: "column",
          order: 1,
          "> div": {
            marginY: 10,
            "> p": {
              marginLeft: "sm",
              fontSize: ["xs", null, "16px", null, null],
            },
          },
        }}
      >
        <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
          {descriptionTitle}
        </Heading>
        <MiljoPointsDescription
          valueGoodChoice={descriptionText[0]}
          valueApproved={descriptionText[1]}
        />
      </Flex>
    ) : null
  ) : null;
};

export default EnvironmentDescription;
